import {RequestMethod} from '#lit/common/constants/index.js';
import {FlyErrorWarning} from '#lit/utils/errors.js';
import {fetcher} from '#lit/utils/http.js';
import type {AudienceExport} from '#lit/types/audience_exports.js';
import {getCSRFToken} from '#lit/utils/auth.js';
import {BASE_URL} from '@typeface-ai/typeface-embed-react/lib/esm/model.js';
import type {SelectedTeam} from '#lit/components/base/sidenav/architecture.js';

const ENDPOINT_URL = '/api/v2/teams/current';

class TeamsService {
  /**
   * Update a dataset
   */
  async update(team: SelectedTeam): Promise<AudienceExport> {
    try {
      // FIXME: Fix use of any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response = await fetcher<any>(ENDPOINT_URL, {
        method: RequestMethod.POST,
        body: team,
        responseParser: 'json',
        headers: {
          'X-CSRF-Token': getCSRFToken(),
        },
      });
      return response;
    } catch (err) {
      new FlyErrorWarning(
        `Error updating: Team: ${team.name}, ID: ${team.id}`,
        {
          label: 'request',
          data: `GET: ${BASE_URL}`,
        },
        {
          label: 'response',
          data: err,
        }
      ).register('Error in teams service');

      throw err;
    }
  }
}

export const teamsService = new TeamsService();
